import Moment from 'moment';

export default class DateHelpers {
    monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    getMonthName = d => {
        return this.monthNames[d];
    };

    formatDate = d => {
        const moment = new Moment(d);
        return this.formatMoment(moment);
    };

    formatMoment = m => {
        return this.formatMomentToString(m, 'DD MMM YYYY');
    };

    formatMomentToString = (m, format) => {
        if (typeof m == "string") {
            return m;
        }
        return m.format(format);
    };

    startOfCurrentMonth() {
        const date = new Date(Moment().year(), Moment().month(), 1)
        return this.formatDate(date);
    }

    endOfCurrentMonth() {
        const date = new Date(Moment().year(), Moment().month() + 1, 1)
        const moment = new Moment(date);
        return this.formatMoment(moment.subtract(1, 'days'));
    }

    startOfPreviousMonth() {
        const date = new Date(Moment().year(), Moment().month() - 1, 1)
        return this.formatDate(date);
    }

    endOfPreviousMonth() {
        const date = new Date(Moment().year(), Moment().month(), 1)
        const moment = new Moment(date).subtract(1, 'days');
        return this.formatMoment(moment);
    }

    convertDateStringToMoment = dateString => {
        const result = Moment(dateString).utc(true);
        return result;
    };

    moveMomentToEndOfDay = m => {

        m.set({
            hour: 23,
            minute: 59, 
            second: 59, 
          });
       
        return m;
    };
}